import React from 'react';
import {
    Row,
    Col,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';

import DatePicker     from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Button         from "reactstrap/es/Button";
import { capitalize } from '../../helpers';

class TimeframePicker extends React.Component {
    constructor(props) {
        super(props);
        var ds = new Date()
        ds.setHours(0);
        ds.setMinutes(0);
        ds.setSeconds(0);
        var de = new Date();
        de.setHours(23);
        de.setMinutes(59);
        de.setSeconds(59);
        this.state ={
            startDate: this.props.startDate ? this.props.startDate : ds,
            endDate: this.props.endDate ? this.props.endDate : de,
            interval: this.props.intervals ? this.props.intervals[0]: '',
            updateLabel: this.props.updateLabel ? this.props.updateLabel : 'Update Charts',
            dropdownOpen: false
        }
    }

    _onUpdateChart = () => {
        const {startDate, endDate, interval} = this.state;
        if (this.props.onUpdateChart) {
            var ed = endDate;
            ed.setHours(23);
            ed.setMinutes(59);
            ed.setSeconds(59);
            var sd = startDate;
            sd.setHours(0);
            sd.setMinutes(0);
            sd.setSeconds(0);
            this.props.onUpdateChart({start: sd, end:ed, interval: interval});
        }
    }

    toggleSelect = () => {
        this.setState({dropdownOpen: !this.state.dropdownOpen})
    }

    render() {
        const {dropdownOpen, interval, updateLabel} = this.state;
        return (
            <>
                <Row>
                    <Col xs={2}>
                        <h5>Start Date:</h5>
                    </Col>
                    <Col xs={2}>
                        <DatePicker
                            selected={this.state.startDate}
                            onChange={(date) => this.setState({startDate: date})}
                            dateFormat={'yyyy-MM-dd'}
                            maxDate={new Date()}
                        />
                    </Col>
                    <Col xs={2}>
                        <h5>End Date:</h5>
                    </Col>
                    <Col xs={2}>
                        <DatePicker
                            selected={this.state.endDate}
                            onChange={(date) => this.setState({endDate: date})}
                            dateFormat={'yyyy-MM-dd'}
                            maxDate={new Date()}
                        />
                    </Col>
                </Row>
                {
                    // disable the interval if it is not required
                    !this.props.disableInterval &&
                    <Row>
                        <Col xs={2}>
                            <h5>Interval:</h5>
                        </Col>
                        <Col xs={2}>
                            <Dropdown isOpen={dropdownOpen} toggle={this.toggleSelect}>
                                <DropdownToggle caret>
                                    {capitalize(interval)}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem header>Interval</DropdownItem>
                                    {this.props.intervals && this.props.intervals.map(tf => {
                                        if (tf === interval) {
                                            return <DropdownItem key={tf} disabled>{capitalize(tf)}</DropdownItem>
                                        } else {
                                            return <DropdownItem key={tf} onClick={ () => this.setState({interval: tf})}>{capitalize(tf)}</DropdownItem>
                                        }
                                    })}
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                    </Row>
                }

                <Row>
                    <Col xs={12}>
                        <Button disabled={this.props.disabled || false} onClick={this._onUpdateChart}>
                            {updateLabel}
                        </Button>
                    </Col>
                </Row>
            </>
        )
    }
}

export default TimeframePicker;